(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header = document.querySelector('[data-app-header]');
  const headerToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const desktopNav = document.querySelector('[data-desktop-nav]');
  const main = document.getElementById('MainContent');
  const footer = document.querySelector('[data-app-footer], .footer');
  const menuMq = window.matchMedia('(max-width: 1100px)');
  const openLabel = headerToggle && headerToggle.getAttribute('data-label-open');
  const closeLabel = headerToggle && headerToggle.getAttribute('data-label-close');

  const setMenuLabel = (open) => {
    if (!headerToggle) return;
    headerToggle.setAttribute('aria-expanded', String(open));
    const text = headerToggle.querySelector('[data-menu-label]');
    if (text) text.textContent = open ? closeLabel : openLabel;
  };

  const setChromeInert = (open) => {
    if (main) main.inert = open;
    if (footer) footer.inert = open;
    if (mobileNav) mobileNav.inert = !open;
  };

  const focusableInMenu = () => {
    if (!mobileNav || !headerToggle) return [];
    return [headerToggle, ...mobileNav.querySelectorAll('a[href], button:not([disabled])')].filter(
      (node) => node && !node.hasAttribute('disabled')
    );
  };

  const closeMenu = ({ restoreFocus = true } = {}) => {
    if (!mobileNav || !headerToggle) return;
    mobileNav.classList.remove('is-open');
    mobileNav.hidden = true;
    if (header) header.classList.remove('is-menu-open');
    closeSubmenus();
    setChromeInert(false);
    setMenuLabel(false);
    if (restoreFocus) headerToggle.focus();
  };

  const openMenu = () => {
    if (!mobileNav || !headerToggle) return;
    mobileNav.classList.add('is-open');
    mobileNav.hidden = false;
    if (header) header.classList.add('is-menu-open');
    setChromeInert(true);
    setMenuLabel(true);
    const first = mobileNav.querySelector('a[href], button:not([disabled])');
    if (first) first.focus();
  };

  const closeSubmenus = () => {
    document.querySelectorAll('[data-nav-item].is-open').forEach((item) => {
      item.classList.remove('is-open');
      const toggle = item.querySelector('[data-nav-sub-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  };

  document.querySelectorAll('[data-nav-sub-toggle]').forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const item = toggle.closest('[data-nav-item]');
      if (!item) return;
      const willOpen = !item.classList.contains('is-open');
      item.parentElement.querySelectorAll('[data-nav-item].is-open').forEach((openItem) => {
        if (openItem !== item) {
          openItem.classList.remove('is-open');
          const other = openItem.querySelector('[data-nav-sub-toggle]');
          if (other) other.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-open', willOpen);
      toggle.setAttribute('aria-expanded', String(willOpen));
    });
  });

  if (headerToggle && mobileNav) {
    headerToggle.addEventListener('click', () => {
      if (mobileNav.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (!mobileNav.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeMenu();
        return;
      }
      if (event.key !== 'Tab') return;
      const items = focusableInMenu();
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  const syncNavA11y = () => {
    if (desktopNav) {
      const hideDesktop = menuMq.matches;
      desktopNav.inert = hideDesktop;
      desktopNav.setAttribute('aria-hidden', String(hideDesktop));
    }
    if (mobileNav && !menuMq.matches) {
      closeMenu({ restoreFocus: false });
    }
  };
  if (menuMq.addEventListener) menuMq.addEventListener('change', syncNavA11y);
  else menuMq.addListener(syncNavA11y);
  syncNavA11y();

  if (header) {
    const syncStuck = () => {
      header.classList.toggle('is-stuck', window.scrollY > 12);
    };
    syncStuck();
    window.addEventListener('scroll', syncStuck, { passive: true });
  }

  document.querySelectorAll('[data-carousel]').forEach((root) => {
    const viewport = root.querySelector('[data-carousel-viewport]');
    const prev = root.querySelector('[data-carousel-prev]');
    const next = root.querySelector('[data-carousel-next]');
    if (!viewport || !prev || !next) return;

    viewport.setAttribute('tabindex', '0');

    const slideWidth = () => {
      const slide = viewport.querySelector('.product-card, .reco-card, .news-card, .gallery-tile');
      if (!slide) return viewport.clientWidth * 0.8;
      const styles = window.getComputedStyle(viewport.querySelector('.carousel__track'));
      const gap = parseFloat(styles.columnGap || styles.gap) || 18;
      return slide.getBoundingClientRect().width + gap;
    };

    const update = () => {
      const max = viewport.scrollWidth - viewport.clientWidth - 2;
      const fits = max <= 0;
      prev.disabled = fits || viewport.scrollLeft <= 2;
      next.disabled = fits || viewport.scrollLeft >= max;
      prev.hidden = fits;
      next.hidden = fits;
      root.classList.toggle('is-start', prev.disabled);
      root.classList.toggle('is-end', next.disabled);
    };

    const behavior = reduceMotion ? 'auto' : 'smooth';
    const go = (dir) => {
      viewport.scrollBy({ left: dir * slideWidth(), behavior });
    };
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    viewport.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        go(1);
      }
    });
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  });

  const previewId = new URLSearchParams(window.location.search).get('preview_theme_id');
  if (previewId) {
    document.querySelectorAll('a[href]').forEach((anchor) => {
      try {
        const url = new URL(anchor.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (!url.searchParams.has('preview_theme_id')) {
          url.searchParams.set('preview_theme_id', previewId);
          anchor.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
        }
      } catch (error) {
        return;
      }
    });
  }

  if (!reduceMotion) {
    document.querySelectorAll('[data-parallax]').forEach((hero) => {
      const layer = hero.querySelector('.hero__media');
      if (!layer) return;

      let ticking = false;
      const sync = () => {
        ticking = false;
        const rect = hero.getBoundingClientRect();
        if (rect.bottom <= 0 || rect.top >= window.innerHeight) {
          hero.classList.remove('is-parallaxing');
          return;
        }

        hero.classList.add('is-parallaxing');
        const maxShift = Math.max(0, layer.offsetHeight - hero.offsetHeight);
        const shift = Math.min(maxShift, Math.max(0, -rect.top * 0.42));
        layer.style.transform = `translate3d(0, ${-shift}px, 0)`;
      };

      const requestSync = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(sync);
      };

      window.addEventListener('scroll', requestSync, { passive: true });
      window.addEventListener('resize', requestSync, { passive: true });
    });

    const revealSelector = [
      '.hero__content > *',
      '.section-heading',
      '.metric',
      '.brand-card',
      '.solutions__cat',
      '.product-card',
      '.reco-card',
      '.insight',
      '.banner',
      '.alliances__pillar',
      '.alliances__card',
      '.news-card',
      '.page-intro__copy > *',
      '.footer__grid > *'
    ].join(',');
    const revealNodes = document.querySelectorAll(revealSelector);
    const groups = new Map();
    revealNodes.forEach((node) => {
      const parent = node.parentElement;
      if (!groups.has(parent)) groups.set(parent, []);
      groups.get(parent).push(node);
    });
    groups.forEach((nodes) => {
      nodes.forEach((node, index) => {
        node.style.setProperty('--reveal-delay', `${index * 0.1}s`);
      });
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -50px 0px' });
    revealNodes.forEach((node) => io.observe(node));

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      const tiltCards = document.querySelectorAll('.product-card, .insight');
      const range = 8;
      tiltCards.forEach((card) => {
        const parent = card.parentElement;
        if (parent) parent.style.perspective = '1000px';
        let currentX = 0;
        let currentY = 0;
        let targetX = 0;
        let targetY = 0;
        let ticking = false;
        const tick = () => {
          currentX += (targetX - currentX) * 0.16;
          currentY += (targetY - currentY) * 0.16;
          const settled =
            Math.abs(targetX) < 0.01 &&
            Math.abs(targetY) < 0.01 &&
            Math.abs(currentX) < 0.05 &&
            Math.abs(currentY) < 0.05;
          if (settled) {
            card.style.transform = '';
            ticking = false;
            return;
          }
          card.style.transform = `rotateX(${currentX.toFixed(2)}deg) rotateY(${currentY.toFixed(2)}deg) translateY(-5px)`;
          requestAnimationFrame(tick);
        };
        const startTick = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(tick);
        };
        card.addEventListener('mousemove', (event) => {
          if (!card.classList.contains('is-in')) return;
          const rect = card.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * range - range / 2;
          const y = ((event.clientY - rect.top) / rect.height) * range - range / 2;
          targetX = y * -1;
          targetY = x;
          startTick();
        });
        card.addEventListener('mouseleave', () => {
          targetX = 0;
          targetY = 0;
          startTick();
        });
      });
    }
  }

  const theme = window.sunderTheme || {};
  const routes = theme.routes || {};
  const cartRoot = () => document.querySelector('[data-cart-drawer]');
  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
  };
  const openCart = () => {
    const drawer = cartRoot();
    if (!drawer) return;
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    document.querySelectorAll('[data-cart-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
    const panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  };
  const closeCart = () => {
    const drawer = cartRoot();
    if (!drawer) return;
    drawer.hidden = true;
    document.body.style.overflow = '';
    document.querySelectorAll('[data-cart-open]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
  };
  const refreshCart = async () => {
    const url = new URL(window.location.origin + (routes.root || '/'));
    url.searchParams.set('section_id', theme.cartSection || 'cart-drawer');
    const preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const res = await fetch(url.toString());
    if (!res.ok) return;
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const next = doc.querySelector('[data-cart-drawer]');
    const current = cartRoot();
    if (next && current) current.replaceWith(next);
    const state = doc.querySelector('[data-cart-state]');
    if (state) {
      try {
        setCartCount(JSON.parse(state.textContent).item_count || 0);
      } catch (error) {
        return;
      }
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }
    const qtyBtn = event.target.closest('[data-cart-qty]');
    if (!qtyBtn) return;
    event.preventDefault();
    const key = qtyBtn.getAttribute('data-key');
    const delta = Number(qtyBtn.getAttribute('data-cart-qty'));
    const row = qtyBtn.closest('[data-key]');
    const currentQty = row ? Number((row.querySelector('.cart-drawer__qty span') || {}).textContent || 1) : 1;
    const quantity = delta === 0 ? 0 : Math.max(0, currentQty + delta);
    fetch(routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(refreshCart);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeCart();
  });

  document.addEventListener('submit', async (event) => {
    const wrap = event.target.closest('[data-product-form]');
    if (!wrap) return;
    event.preventDefault();
    const form = wrap.querySelector('form') || event.target;
    const res = await fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });
    if (!res.ok) return;
    await refreshCart();
    openCart();
  });

  document.querySelectorAll('[data-dose-calc]').forEach((calc) => {
    const rate = Number(calc.getAttribute('data-rate')) || 400;
    const bag = Number(calc.getAttribute('data-bag')) || 50;
    const areaInput = calc.querySelector('[data-dose-area]');
    const bagsEl = calc.querySelector('[data-dose-bags]');
    const kgEl = calc.querySelector('[data-dose-kg]');
    const qtyInput = document.getElementById(calc.getAttribute('data-qty-input') || '');
    const areaProp = document.querySelector('[data-cart-area]');
    const rateProp = document.querySelector('[data-cart-rate]');
    if (!areaInput) return;

    const sync = () => {
      const area = Math.max(0.5, Number(areaInput.value) || 1);
      areaInput.value = String(area);
      const kg = area * rate;
      const bags = Math.max(1, Math.ceil(kg / bag));
      if (bagsEl) bagsEl.textContent = String(bags);
      if (kgEl) kgEl.textContent = String(Math.round(kg));
      if (areaProp) areaProp.value = String(area);
      if (rateProp) rateProp.value = String(rate);
      if (qtyInput) qtyInput.value = String(bags);
      return bags;
    };

    calc.querySelectorAll('[data-dose-step]').forEach((btn) => {
      btn.addEventListener('click', () => {
        areaInput.value = String(Math.max(0.5, (Number(areaInput.value) || 1) + Number(btn.getAttribute('data-dose-step'))));
        sync();
      });
    });
    areaInput.addEventListener('input', sync);
    const apply = calc.querySelector('[data-dose-apply]');
    if (apply) apply.addEventListener('click', sync);
    sync();
  });

  const nutriButtons = [...document.querySelectorAll('[data-cat]')];
  const nutriCards = [...document.querySelectorAll('[data-product-cat]')];
  const catalogRoot = document.querySelector('[data-catalog-more]');
  const catalogLimit = catalogRoot
    ? Math.max(1, Number(catalogRoot.getAttribute('data-catalog-more')) || 8)
    : 0;
  const catalogCards = catalogRoot ? [...catalogRoot.querySelectorAll('.product-card')] : [];
  const catalogExtras = catalogCards.slice(catalogLimit);
  const catalogMoreWrap = document.querySelector('.home-catalog__more');
  const catalogMoreBtn = document.querySelector('[data-catalog-more-btn]');
  let catalogOpen = catalogExtras.length === 0;

  catalogExtras.forEach((card) => {
    card.setAttribute('data-catalog-extra', '');
    card.hidden = true;
  });

  const syncCatalogMore = (cat) => {
    if (!catalogMoreWrap) return;
    const showBtn = Boolean(catalogExtras.length) && !catalogOpen && (!cat || cat === 'all');
    catalogMoreWrap.hidden = !showBtn;
  };

  if (catalogMoreBtn) {
    catalogMoreBtn.addEventListener('click', () => {
      catalogOpen = true;
      catalogExtras.forEach((card) => {
        card.hidden = false;
      });
      syncCatalogMore('all');
    });
  }
  syncCatalogMore('all');

  if (nutriButtons.length && nutriCards.length) {
    const empties = [...document.querySelectorAll('[data-cat-empty]')];
    const present = new Set(nutriCards.map((card) => card.getAttribute('data-product-cat')));

    nutriButtons.forEach((btn) => {
      const cat = btn.getAttribute('data-cat');
      if (cat && cat !== 'all' && !present.has(cat)) {
        btn.hidden = true;
      }
    });

    const applyCat = (cat, scroll) => {
      nutriButtons.forEach((btn) => {
        if (btn.hidden) return;
        btn.classList.toggle('is-active', btn.getAttribute('data-cat') === cat);
      });
      let visible = 0;
      nutriCards.forEach((card) => {
        const match = cat === 'all' || card.getAttribute('data-product-cat') === cat;
        const extraCollapsed = cat === 'all' && !catalogOpen && card.hasAttribute('data-catalog-extra');
        card.hidden = !match || extraCollapsed;
        if (match && !extraCollapsed) visible += 1;
      });
      empties.forEach((empty) => {
        empty.hidden = visible > 0;
      });
      syncCatalogMore(cat);
      if (scroll) {
        const grid = document.querySelector('#linea-nutricampo') || document.querySelector('#linea');
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    nutriButtons.forEach((btn) => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        const cat = btn.getAttribute('data-cat');
        const inCatalog = btn.closest('#linea-nutricampo, #linea, [data-nutri-explore]');
        applyCat(cat, !inCatalog);
      });
    });

    const start = new URLSearchParams(window.location.search).get('cat') || 'all';
    if (start !== 'all' && present.has(start)) applyCat(start, false);
  }

  document.querySelectorAll('[data-gallery]').forEach((root) => {
    const dialog = root.querySelector('[data-gallery-dialog]');
    const full = dialog && dialog.querySelector('[data-gallery-full]');
    const count = dialog && dialog.querySelector('[data-gallery-count]');
    const closeBtn = dialog && dialog.querySelector('[data-gallery-close]');
    const prevBtn = dialog && dialog.querySelector('[data-gallery-prev]');
    const nextBtn = dialog && dialog.querySelector('[data-gallery-next]');
    const tiles = [...root.querySelectorAll('[data-gallery-open]')];
    if (!dialog || !full || tiles.length === 0) return;

    let index = 0;
    const template = dialog.getAttribute('data-count-template') || '__CURRENT__ / __TOTAL__';

    const show = (nextIndex) => {
      index = (nextIndex + tiles.length) % tiles.length;
      const tile = tiles[index];
      full.src = tile.getAttribute('data-gallery-src') || '';
      full.alt = tile.getAttribute('data-gallery-alt') || '';
      if (count) {
        count.textContent = template
          .replace('__CURRENT__', String(index + 1))
          .replace('__TOTAL__', String(tiles.length));
      }
      if (!dialog.open) dialog.showModal();
      if (closeBtn) closeBtn.focus();
    };

    tiles.forEach((tile, tileIndex) => {
      tile.addEventListener('click', () => show(tileIndex));
    });
    if (closeBtn) closeBtn.addEventListener('click', () => dialog.close());
    if (prevBtn) prevBtn.addEventListener('click', () => show(index - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => show(index + 1));
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        show(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + 1);
      }
    });
    dialog.addEventListener('close', () => {
      const tile = tiles[index];
      if (tile) tile.focus();
    });
  });

  document.querySelectorAll('[data-qty-step]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      input.value = String(Math.max(1, (Number(input.value) || 1) + Number(btn.getAttribute('data-qty-step'))));
    });
  });

  if (document.body.classList.contains('template-404')) {
    const views = {
      nutricampo: 'nutricampo',
      biofertech: 'biofertech',
      recursos: 'recursos',
      inversiones: 'inversiones',
      'medio-ambiente': 'medio-ambiente',
      contacto: 'contacto',
      alianzas: 'alianzas',
      recomendador: 'recomendador',
      'sobre-sunder': 'sunder',
      privacidad: 'privacidad',
      terminos: 'terminos',
      'actualidad-del-agro': 'noticias',
      noticias: 'noticias'
    };
    const parts = window.location.pathname.split('/').filter(Boolean);
    const slug = parts[parts.length - 1];
    const view = views[slug];
    if (view) {
      const next = new URL(window.location.origin);
      next.pathname = '/';
      const current = new URLSearchParams(window.location.search);
      current.forEach((value, key) => next.searchParams.set(key, value));
      next.searchParams.set('view', view);
      window.location.replace(next.toString());
    }
  }
})();
